<template>
  <div class="project">
    <div class="top-img">
      <img style="width: 100%;" src="@/assets/images/k2hqdmpfendk2hqdmpfend.jpg"
           alt="YwgA84rAI">
    </div>
    <DeputyProject/>
    <MainProject/>
    <SpecialSubject/>
    <el-dialog :visible.sync="dialogArticleVisible">
      <div class="article-model" v-html='content.replace(/<img src/g, "<img data-src")' v-lazy-container="{ selector: 'img' }"></div>
      <el-empty :image-size="200" v-if="content.length === 0"></el-empty>
    </el-dialog>
  </div>
</template>

<script>
import DeputyProject from './DeputyProject'
import MainProject from './MainProject'
import SpecialSubject from './SpecialSubject'

export default {
  name: "Project",
  components: {DeputyProject, MainProject, SpecialSubject},
  data() {
    return {
      dialogArticleVisible: false,
      content: "",
    }
  },
  methods: {
    showContent(content) {
      this.dialogArticleVisible = true
      this.content = content
    }
  },
  mounted() {
    this.goAnchorModel(this)

    this.$bus.$on("showContent", this.showContent)
  },
  beforeDestroy() {
    this.$bus.$off("showContent")
  }
}
</script>

<style scoped lang="less">
.project {

}

/deep/ .el-dialog {
  margin-top: 5vh !important;
  padding: 60px 0;
  width: 1150px;

  .el-dialog__body {
    margin: auto;
    width: 900px;

    .article-model {
      min-height: 600px;
    }
  }
}
</style>